import { DataSoldProductsByVendor, FetchSoldProductsSearchProps, ListSoldProductsByVendor } from 'lib/models/listSoldProducts';
import { useCallback, useEffect, useState } from 'react';

function useListSoldProducts(searchProps?: FetchSoldProductsSearchProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [soldProductsByVendor, setSoldProductsByVendor] = useState<DataSoldProductsByVendor>(
		{} as DataSoldProductsByVendor
	);

	const refetch = useCallback(async (props?: FetchSoldProductsSearchProps) => {
		setLoading(true);
		const response = await ListSoldProductsByVendor(props || searchProps);
		setSoldProductsByVendor(response);
		setLoading(false);
	}, [searchProps]);

	useEffect(() => {
		refetch(searchProps);
	}, [refetch, searchProps]);

	return { loading, soldProductsByVendor, refetch, setLoading };
}

export default useListSoldProducts;
